import request from '@/util/request'

export const imeiValidator = (scope) => (rule, value, callback) => {
  console.log(scope)
  if (value === '') {
    if (rule.required) callback(new Error('请输入IMEI'));
  } else {
    request.carIdleImei({search:{imei:value}}).then(resp => {
      let hit = resp.data.list
      if(hit.length == 0){
        callback(new Error('该设备不存在'))
      }
      else if(hit.length == 1){
        if(hit[0].carNo){
          callback(new Error('该设备已被绑定'))
        }else{
          callback()
        }
      }else{
        callback(new Error('该设备不可用，未知错误'))
      }
    })
  }
}